<template>
    <footer class="app-footer">
        <div class="inner-body-block">
            <div class="menu">
                <div class="logo">
                    <img src="~/assets/icons/header/logo.svg" alt="Трия">
                </div>
                <div class="d-column">
                    <span>О компании</span>
                    <nuxt-link to="/about/company/">О компании</nuxt-link>
                    <nuxt-link to="/about/contacts/">Контакты</nuxt-link>
                    <nuxt-link to="/about/vacancy/">Вакансии</nuxt-link>
                    <nuxt-link to="/about/franchising/">Франшиза</nuxt-link>
                    <nuxt-link to="/about/tender/">Сотрудничество</nuxt-link>
                </div>
                <div class="d-column">
                    <span>Покупателю</span>
                    <nuxt-link to="/about/delivery/#delivery">Доставка и сборка</nuxt-link>
                    <nuxt-link to="/about/delivery/#payment">Оплата</nuxt-link>
                    <nuxt-link to="/promo/credit/">Рассрочка</nuxt-link>
                    <nuxt-link to="/about/warranty/">Гарантии</nuxt-link>
                    <nuxt-link to="/catalog/discont/">Распродажа</nuxt-link>
                    <!-- <a href="/3d/">3D Планировщик</a> -->
                    <nuxt-link to="/about/stores/">Адреса магазинов</nuxt-link>
                    <nuxt-link to="/about/legal/">Документы</nuxt-link>
                    <!-- <a href="/about/ecology/">Экологичные инициативы</a> -->
                </div>
                <div class="d-column">
                    <span>Каталоги</span>
                    <nuxt-link to="/about/catalogs/corpus/">Корпусная мебель</nuxt-link>
                    <nuxt-link to="/about/catalogs/malogabarit/">Малогабаритная мебель</nuxt-link>
                    <nuxt-link to="/about/catalogs/export/">Мебель 2024-2025</nuxt-link>
                    <nuxt-link to="/about/catalogs/matras/">Матрасы</nuxt-link>
                    <nuxt-link to="/about/catalogs/table_chair/">Столы и стулья</nuxt-link>
                    <!-- <a href="/about/awards/">Сертификаты</a> -->
                </div>

                <div class="d-column">
                    <span>Контакты</span>
                    <div class="small">Звонок по России бесплатный</div>
                    <div>{{ phones }}</div>
                    <div class="small">Режим работы интернет-магазина</div>
                    <div>{{ workingTime }}</div>

                    <template v-if="region?.retail.count">
                        <div class="small">Адрес салона</div>
                        <div>{{ region.retail.address }}</div>
                    </template>

                    <nuxt-link href="/about/stores/">Все магазины</nuxt-link>

                    <!-- {{ region?.retail }} -->
                    <!-- {{ phones }} -->
                    <!-- <p>
                        .<br>
                        Режим работы интернет-магазина:<br>
                        
                    </p>
                    <p>
                        
                    </p> -->
                </div>
                
            </div>
            <div class="bottom">
                <div class="social-icons">
                    <a v-for="icon of socialIcons" 
                        target="_blank"
                        rel="nofollow noopener" 
                        :key="icon.href"
                        :href="icon.href">
                        <img :src="icon.icon">
                    </a>
                </div>
                <div class="copyright">
                    Группа компаний &laquo;ТриЯ&raquo;, {{ year }} &copy;
                </div>
            </div>
        </div>
    </footer>
</template>

<script lang="ts" setup>
import { getFormattedTime } from '~/plugins/money';
import { useMainStore } from '~~/store/mainState';

import tgIcon from '~/assets/icons/social/tg.svg?url';
import vkIcon from '~/assets/icons/social/vk.svg?url';
import okIcon from '~/assets/icons/social/ok.svg?url';


const region = computed(() => useMainStore().location);
const phones = computed(() => region.value!.contact.phones.join(', '));
const year = (new Date()).getFullYear();

const workingTime = computed(() => {
    const today = (new Date()).toISOString().slice(0, 10);
    return `с ${getFormattedTime(new Date(`${today}T08:00:00+03:00`))} - ${getFormattedTime(new Date(`${today}T21:00:00+03:00`))}`;
});


const socialIcons = [{
    href: 'https://t.me/triyaru',
    icon: tgIcon,
}, {
    href: 'https://vk.com/triyaru',
    icon: vkIcon,
}, {
    href: 'https://www.odnoklassniki.ru/triyaru',
    icon: okIcon,
}];

</script>

<style lang="scss" scoped>
@use '~/assets/css/colors.scss' as *;

.app-footer {
    background-color: var(--bg2);
    // padding: 20px;
    padding: 60px 0 20px 0;
    font-size: 16px;
    color: var(--t0);
    // color: $color-text-light;
    display: flex;
    justify-content: space-between;
}

.menu {
    display: grid;
    grid-template-columns: repeat(6, 1fr);

    .d-column {
        // width: 330px;

        &>* {
            display: block;
            margin-bottom: 12px;
        }

        span {
            margin-bottom: 4px;
            font-weight: 550;
            font-size: 20px;
            margin-bottom: 20px;
        }

        a {
            font-size: 16px;
            font-weight: 350;
            text-decoration: none;
            color: black;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    .small {
        font-weight: 350;
        font-size: 14px;
        color: var(--t1);
        margin-bottom: 8px;
    }
}

.copyright {
    color: var(--t2);
    font-weight: 500;
    font-size: 14px;
    font-weight: 400;
}

.bottom {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}

.logo img {
    width: 107px;
}

.social-icons {
    display: flex;
    gap: 16px;

    img {
        width: 40px;
        height: 40px;
    }
}

</style>